import { BlockBody } from '@medifind/containers';
import { toSlug } from '@medifind/router';
import { MFLink, ScoreBars, ScoreLabel } from '@medifind/shared-basic-components';
import styles from './ConditionAvailability.module.scss';

const ConditionAvailabilityResult = ({ conditions, displayName, conditionAvailability }) => {
  const conditionScore = conditions.find((obj) => {
    return obj.projectId === conditionAvailability['projectId'];
  });

  return (
    <BlockBody className={styles['condition-availability__result-body']}>
      {conditionScore?.score === undefined ? (
        <p>
          {displayName} does not appear to focus on treating {conditionAvailability?.codingName}.
          <br />
          <MFLink
            to={`/${conditionAvailability?.codingType}s/${toSlug(conditionAvailability?.codingName)}/${
              conditionAvailability.projectId
            }/doctors`}
          >
            Click here to find experts who treat {conditionAvailability?.codingName}
          </MFLink>
          .
        </p>
      ) : null}
      {conditionScore?.score >= 5 ? (
        <>
          <div>
            {displayName} is{' '}
            <ScoreLabel score={conditionScore?.score} classes={{ label: styles['condition-availability__score-label-blue'] }} /> in{' '}
            <MFLink to={`/conditions/${toSlug(conditionAvailability?.codingName)}/${conditionAvailability.projectId}/doctors`}>
              {conditionAvailability?.codingName}
            </MFLink>
          </div>
          <div className={styles['condition-availability__score-container']}>
            <ScoreBars score={conditionScore?.score} bigBars className={styles['condition-availability__score-bar']} center />
            <ScoreLabel score={conditionScore?.score} classes={{ label: styles['condition-availability__score-label'] }} />
          </div>
        </>
      ) : null}
      {conditionScore?.score === null || conditionScore?.score < 5 ? (
        <>
          <div>
            {displayName} specifies that{' '}
            <MFLink to={`/conditions/${toSlug(conditionAvailability?.codingName)}/${conditionAvailability.projectId}/doctors`}>
              {conditionAvailability?.codingName}
            </MFLink>{' '}
            is an area of focus.
          </div>
        </>
      ) : null}
    </BlockBody>
  );
};

export { ConditionAvailabilityResult as default, ConditionAvailabilityResult };
